const state = {
  countries: [{
      country_id: 1,
      name_ru: "Албания",
      name_en: "Albania",
      iso_num: 8,
      iso_2: "AL",
      iso_3: "ALB"
    },
    {
      country_id: 2,
      name_ru: "Алжир",
      name_en: "Algeria",
      iso_num: 12,
      iso_2: "DZ",
      iso_3: "DZA"
    },
    {
      country_id: 3,
      name_ru: "Американский Самоа",
      name_en: "American Samoa",
      iso_num: 16,
      iso_2: "AS",
      iso_3: "ASM"
    },
    {
      country_id: 4,
      name_ru: "Андорра",
      name_en: "Andorra",
      iso_num: 20,
      iso_2: "AD",
      iso_3: "AND"
    },
    {
      country_id: 5,
      name_ru: "Ангола",
      name_en: "Angola",
      iso_num: 24,
      iso_2: "AO",
      iso_3: "AGO"
    },
    {
      country_id: 6,
      name_ru: "Ангилья",
      name_en: "Anguilla",
      iso_num: 660,
      iso_2: "AI",
      iso_3: "AIA"
    },
    {
      country_id: 8,
      name_ru: "Антигуа и Барбуда",
      name_en: "Antigua and Barbuda",
      iso_num: 28,
      iso_2: "AG",
      iso_3: "ATG"
    },
    {
      country_id: 9,
      name_ru: "Аргентина",
      name_en: "Argentina",
      iso_num: 32,
      iso_2: "AR",
      iso_3: "ARG"
    },
    {
      country_id: 10,
      name_ru: "Армения",
      name_en: "Armenia",
      iso_num: 51,
      iso_2: "AM",
      iso_3: "ARM"
    },
    {
      country_id: 11,
      name_ru: "Аруба",
      name_en: "Aruba",
      iso_num: 533,
      iso_2: "AW",
      iso_3: "ABW"
    },
    {
      country_id: 13,
      name_ru: "Австралия",
      name_en: "Australia",
      iso_num: 36,
      iso_2: "AU",
      iso_3: "AUS"
    },
    {
      country_id: 14,
      name_ru: "Австрия",
      name_en: "Austria",
      iso_num: 40,
      iso_2: "AT",
      iso_3: "AUT"
    },
    {
      country_id: 15,
      name_ru: "Азербайджан",
      name_en: "Azerbaijan",
      iso_num: 31,
      iso_2: "AZ",
      iso_3: "AZE"
    },
    {
      country_id: 16,
      name_ru: "Багамские острова",
      name_en: "Bahamas",
      iso_num: 44,
      iso_2: "BS",
      iso_3: "BHS"
    },
    {
      country_id: 17,
      name_ru: "Бахрейн",
      name_en: "Bahrain",
      iso_num: 48,
      iso_2: "BH",
      iso_3: "BHR"
    },
    {
      country_id: 18,
      name_ru: "Бангладеш",
      name_en: "Bangladesh",
      iso_num: 50,
      iso_2: "BD",
      iso_3: "BGD"
    },
    {
      country_id: 19,
      name_ru: "Барбадос",
      name_en: "Barbados",
      iso_num: 52,
      iso_2: "BB",
      iso_3: "BRB"
    },
    {
      country_id: 20,
      name_ru: "Беларусь",
      name_en: "Belarus",
      iso_num: 112,
      iso_2: "BY",
      iso_3: "BLR"
    },
    {
      country_id: 21,
      name_ru: "Бельгия",
      name_en: "Belgium",
      iso_num: 56,
      iso_2: "BE",
      iso_3: "BEL"
    },
    {
      country_id: 22,
      name_ru: "Белиз",
      name_en: "Belize",
      iso_num: 84,
      iso_2: "BZ",
      iso_3: "BLZ"
    },
    {
      country_id: 23,
      name_ru: "Бенин",
      name_en: "Benin",
      iso_num: 204,
      iso_2: "BJ",
      iso_3: "BEN"
    },
    {
      country_id: 24,
      name_ru: "Бермуды",
      name_en: "Bermuda",
      iso_num: 60,
      iso_2: "BM",
      iso_3: "BMU"
    },
    {
      country_id: 25,
      name_ru: "Бутан",
      name_en: "Bhutan",
      iso_num: 64,
      iso_2: "BT",
      iso_3: "BTN"
    },
    {
      country_id: 26,
      name_ru: "Боливия",
      name_en: "Bolivia",
      iso_num: 68,
      iso_2: "BO",
      iso_3: "BOL"
    },
    {
      country_id: 27,
      name_ru: "Босния и Герцеговина",
      name_en: "Bosnia and Herzegovina",
      iso_num: 70,
      iso_2: "BA",
      iso_3: "BIH"
    },
    {
      country_id: 28,
      name_ru: "Ботсвана",
      name_en: "Botswana",
      iso_num: 72,
      iso_2: "BW",
      iso_3: "BWA"
    },
    {
      country_id: 30,
      name_ru: "Бразилия",
      name_en: "Brazil",
      iso_num: 76,
      iso_2: "BR",
      iso_3: "BRA"
    },
    {
      country_id: 31,
      name_ru: "Британские территории Индийского океана",
      name_en: "British Indian Ocean Territory",
      iso_num: 86,
      iso_2: "IO",
      iso_3: "IOT"
    },
    {
      country_id: 32,
      name_ru: "Бруней",
      name_en: "Brunei",
      iso_num: 96,
      iso_2: "BN",
      iso_3: "BRN"
    },
    {
      country_id: 33,
      name_ru: "Болгария",
      name_en: "Bulgaria",
      iso_num: 100,
      iso_2: "BG",
      iso_3: "BGR"
    },
    {
      country_id: 34,
      name_ru: "Буркина Фасо",
      name_en: "Burkina Faso",
      iso_num: 854,
      iso_2: "BF",
      iso_3: "BFA"
    },
    {
      country_id: 35,
      name_ru: "Бурунди",
      name_en: "Burundi",
      iso_num: 108,
      iso_2: "BI",
      iso_3: "BDI"
    },
    {
      country_id: 36,
      name_ru: "Камбоджа",
      name_en: "Cambodia",
      iso_num: 116,
      iso_2: "KH",
      iso_3: "KHM"
    },
    {
      country_id: 37,
      name_ru: "Камерун",
      name_en: "Cameroon",
      iso_num: 120,
      iso_2: "CM",
      iso_3: "CMR"
    },
    {
      country_id: 38,
      name_ru: "Канада",
      name_en: "Canada",
      iso_num: 124,
      iso_2: "CA",
      iso_3: "CAN"
    },
    {
      country_id: 39,
      name_ru: "о-ва Зеленого Мыса",
      name_en: "Cape Verde",
      iso_num: 132,
      iso_2: "CV",
      iso_3: "CPV"
    },
    {
      country_id: 40,
      name_ru: "Каймановы острова",
      name_en: "Cayman Islands",
      iso_num: 136,
      iso_2: "KY",
      iso_3: "CYM"
    },
    {
      country_id: 41,
      name_ru: "Центральная Африканская Республика",
      name_en: "Central African Republic",
      iso_num: 140,
      iso_2: "CF",
      iso_3: "CAF"
    },
    {
      country_id: 42,
      name_ru: "Чад",
      name_en: "Chad",
      iso_num: 148,
      iso_2: "TD",
      iso_3: "TCD"
    },
    {
      country_id: 44,
      name_ru: "Чили",
      name_en: "Chile",
      iso_num: 152,
      iso_2: "CL",
      iso_3: "CHL"
    },
    {
      country_id: 45,
      name_ru: "Китай",
      name_en: "China",
      iso_num: 156,
      iso_2: "CN",
      iso_3: "CHN"
    },
    {
      country_id: 46,
      name_ru: "остров Рождества",
      name_en: "Christmas Island",
      iso_num: 162,
      iso_2: "CX",
      iso_3: "CXR"
    },
    {
      country_id: 47,
      name_ru: "Кокосовые острова",
      name_en: "Cocos (Keeling) Islands",
      iso_num: 166,
      iso_2: "CC",
      iso_3: "CCK"
    },
    {
      country_id: 48,
      name_ru: "Колумбия",
      name_en: "Colombia",
      iso_num: 170,
      iso_2: "CO",
      iso_3: "COL"
    },
    {
      country_id: 49,
      name_ru: "Коморские острова",
      name_en: "Comoros",
      iso_num: 174,
      iso_2: "KM",
      iso_3: "COM"
    },
    {
      country_id: 50,
      name_ru: "Республика Конго",
      name_en: "Congo",
      iso_num: 178,
      iso_2: "CG",
      iso_3: "COG"
    },
    {
      country_id: 51,
      name_ru: "Демократическая республика Конго",
      name_en: "Congo, Democractic Republic",
      iso_num: 180,
      iso_2: "CD",
      iso_3: "COD"
    },
    {
      country_id: 52,
      name_ru: "острова Кука",
      name_en: "Cook Islands",
      iso_num: 184,
      iso_2: "CK",
      iso_3: "COK"
    },
    {
      country_id: 53,
      name_ru: "Коста Рика",
      name_en: "Costa Rica",
      iso_num: 188,
      iso_2: "CR",
      iso_3: "CRI"
    },
    {
      country_id: 54,
      name_ru: "Кот-д'Ивуар",
      name_en: "Cote D'Ivoire",
      iso_num: 384,
      iso_2: "CI",
      iso_3: "CIV"
    },
    {
      country_id: 55,
      name_ru: "Хорватия",
      name_en: "Croatia",
      iso_num: 191,
      iso_2: "HR",
      iso_3: "HRV"
    },
    {
      country_id: 56,
      name_ru: "Куба",
      name_en: "Cuba",
      iso_num: 192,
      iso_2: "CU",
      iso_3: "CUB"
    },
    {
      country_id: 57,
      name_ru: "Кипр",
      name_en: "Cyprus",
      iso_num: 196,
      iso_2: "CY",
      iso_3: "CYP"
    },
    {
      country_id: 58,
      name_ru: "Чехия",
      name_en: "Czech Republic",
      iso_num: 203,
      iso_2: "CZ",
      iso_3: "CZE"
    },
    {
      country_id: 59,
      name_ru: "Дания",
      name_en: "Denmark",
      iso_num: 208,
      iso_2: "DK",
      iso_3: "DNK"
    },
    {
      country_id: 60,
      name_ru: "Джибути",
      name_en: "Djibouti",
      iso_num: 262,
      iso_2: "DJ",
      iso_3: "DJI"
    },
    {
      country_id: 61,
      name_ru: "Доминика",
      name_en: "Dominica",
      iso_num: 212,
      iso_2: "DM",
      iso_3: "DMA"
    },
    {
      country_id: 62,
      name_ru: "Доминиканская республика",
      name_en: "Dominican Republic",
      iso_num: 214,
      iso_2: "DO",
      iso_3: "DOM"
    },
    {
      country_id: 63,
      name_ru: "Эквадор",
      name_en: "Ecuador",
      iso_num: 218,
      iso_2: "EC",
      iso_3: "ECU"
    },
    {
      country_id: 64,
      name_ru: "Египет",
      name_en: "Egypt",
      iso_num: 818,
      iso_2: "EG",
      iso_3: "EGY"
    },
    {
      country_id: 65,
      name_ru: "Сальвадор",
      name_en: "El Salvador",
      iso_num: 222,
      iso_2: "SV",
      iso_3: "SLV"
    },
    {
      country_id: 67,
      name_ru: "Экваториальная Гвинея",
      name_en: "Equatorial Guinea",
      iso_num: 226,
      iso_2: "GQ",
      iso_3: "GNQ"
    },
    {
      country_id: 68,
      name_ru: "Эритрея",
      name_en: "Eritrea",
      iso_num: 232,
      iso_2: "ER",
      iso_3: "ERI"
    },
    {
      country_id: 69,
      name_ru: "Эстония",
      name_en: "Estonia",
      iso_num: 233,
      iso_2: "EE",
      iso_3: "EST"
    },
    {
      country_id: 70,
      name_ru: "Эфиопия",
      name_en: "Ethiopia",
      iso_num: 231,
      iso_2: "ET",
      iso_3: "ETH"
    },
    {
      country_id: 72,
      name_ru: "Фарерские острова",
      name_en: "Faroe Islands",
      iso_num: 234,
      iso_2: "FO",
      iso_3: "FRO"
    },
    {
      country_id: 73,
      name_ru: "Фолклендские (Мальвинские) острова",
      name_en: "Falkland Islands (Malvinas)",
      iso_num: 238,
      iso_2: "FK",
      iso_3: "FLK"
    },
    {
      country_id: 74,
      name_ru: "Фиджи",
      name_en: "Fiji",
      iso_num: 242,
      iso_2: "FJ",
      iso_3: "FJI"
    },
    {
      country_id: 75,
      name_ru: "Финляндия",
      name_en: "Finland",
      iso_num: 246,
      iso_2: "FI",
      iso_3: "FIN"
    },
    {
      country_id: 76,
      name_ru: "Франция",
      name_en: "France",
      iso_num: 250,
      iso_2: "FR",
      iso_3: "FRA"
    },
    {
      country_id: 77,
      name_ru: "Французская Гвиана",
      name_en: "French Guiana",
      iso_num: 254,
      iso_2: "GF",
      iso_3: "GUF"
    },
    {
      country_id: 78,
      name_ru: "Французская Полинезия",
      name_en: "French Polynesia",
      iso_num: 258,
      iso_2: "PF",
      iso_3: "PYF"
    },
    {
      country_id: 79,
      name_ru: "Французские Южные Территории",
      name_en: "French Southern Territories",
      iso_num: 260,
      iso_2: "TF",
      iso_3: "ATF"
    },
    {
      country_id: 80,
      name_ru: "Габон",
      name_en: "Gabon",
      iso_num: 266,
      iso_2: "GA",
      iso_3: "GAB"
    },
    {
      country_id: 81,
      name_ru: "Гамбия",
      name_en: "Gambia",
      iso_num: 270,
      iso_2: "GM",
      iso_3: "GMB"
    },
    {
      country_id: 82,
      name_ru: "Грузия",
      name_en: "Georgia",
      iso_num: 268,
      iso_2: "GE",
      iso_3: "GEO"
    },
    {
      country_id: 83,
      name_ru: "Германия",
      name_en: "Germany",
      iso_num: 276,
      iso_2: "DE",
      iso_3: "DEU"
    },
    {
      country_id: 84,
      name_ru: "Гана",
      name_en: "Ghana",
      iso_num: 288,
      iso_2: "GH",
      iso_3: "GHA"
    },
    {
      country_id: 85,
      name_ru: "Гибралтар",
      name_en: "Gibraltar",
      iso_num: 292,
      iso_2: "GI",
      iso_3: "GIB"
    },
    {
      country_id: 86,
      name_ru: "Греция",
      name_en: "Greece",
      iso_num: 300,
      iso_2: "GR",
      iso_3: "GRC"
    },
    {
      country_id: 87,
      name_ru: "Гренландия",
      name_en: "Greenland",
      iso_num: 304,
      iso_2: "GL",
      iso_3: "GRL"
    },
    {
      country_id: 88,
      name_ru: "Гренада",
      name_en: "Grenada",
      iso_num: 308,
      iso_2: "GD",
      iso_3: "GRD"
    },
    {
      country_id: 89,
      name_ru: "Гваделупа",
      name_en: "Guadeloupe",
      iso_num: 312,
      iso_2: "GP",
      iso_3: "GLP"
    },
    {
      country_id: 90,
      name_ru: "Гуам",
      name_en: "Guam",
      iso_num: 316,
      iso_2: "GU",
      iso_3: "GUM"
    },
    {
      country_id: 91,
      name_ru: "Гватемала",
      name_en: "Guatemala",
      iso_num: 320,
      iso_2: "GT",
      iso_3: "GTM"
    },
    {
      country_id: 92,
      name_ru: "Гвинея",
      name_en: "Guinea",
      iso_num: 324,
      iso_2: "GN",
      iso_3: "GIN"
    },
    {
      country_id: 93,
      name_ru: "Гвинея-Бисау",
      name_en: "Guinea-Bissau",
      iso_num: 624,
      iso_2: "GW",
      iso_3: "GNB"
    },
    {
      country_id: 94,
      name_ru: "Гайана",
      name_en: "Guyana",
      iso_num: 328,
      iso_2: "GY",
      iso_3: "GUY"
    },
    {
      country_id: 95,
      name_ru: "Гаити",
      name_en: "Haiti",
      iso_num: 332,
      iso_2: "HT",
      iso_3: "HTI"
    },
    {
      country_id: 96,
      name_ru: "о-ва Герда и МакДональда",
      name_en: "Heard Island and McDonald Islands",
      iso_num: 334,
      iso_2: "HM",
      iso_3: "HMD"
    },
    {
      country_id: 97,
      name_ru: "Гондурас",
      name_en: "Honduras",
      iso_num: 340,
      iso_2: "HN",
      iso_3: "HND"
    },
    {
      country_id: 98,
      name_ru: "Гонконг (Китай)",
      name_en: "Hong Kong (China)",
      iso_num: 344,
      iso_2: "HK",
      iso_3: "HKG"
    },
    {
      country_id: 99,
      name_ru: "Венгрия",
      name_en: "Hungary",
      iso_num: 348,
      iso_2: "HU",
      iso_3: "HUN"
    },
    {
      country_id: 100,
      name_ru: "Исландия",
      name_en: "Iceland",
      iso_num: 352,
      iso_2: "IS",
      iso_3: "ISL"
    },
    {
      country_id: 102,
      name_ru: "Индия",
      name_en: "India",
      iso_num: 356,
      iso_2: "IN",
      iso_3: "IND"
    },
    {
      country_id: 103,
      name_ru: "Индонезия",
      name_en: "Indonesia",
      iso_num: 360,
      iso_2: "ID",
      iso_3: "IDN"
    },
    {
      country_id: 104,
      name_ru: "Иран",
      name_en: "Iran",
      iso_num: 364,
      iso_2: "IR",
      iso_3: "IRN"
    },
    {
      country_id: 105,
      name_ru: "Ирак",
      name_en: "Iraq",
      iso_num: 368,
      iso_2: "IQ",
      iso_3: "IRQ"
    },
    {
      country_id: 106,
      name_ru: "Ирландия",
      name_en: "Ireland",
      iso_num: 372,
      iso_2: "IE",
      iso_3: "IRL"
    },
    {
      country_id: 108,
      name_ru: "Израиль",
      name_en: "Israel",
      iso_num: 376,
      iso_2: "IL",
      iso_3: "ISR"
    },
    {
      country_id: 109,
      name_ru: "Италия",
      name_en: "Italy",
      iso_num: 380,
      iso_2: "IT",
      iso_3: "ITA"
    },
    {
      country_id: 110,
      name_ru: "Ямайка",
      name_en: "Jamaica",
      iso_num: 388,
      iso_2: "JM",
      iso_3: "JAM"
    },
    {
      country_id: 111,
      name_ru: "Япония",
      name_en: "Japan",
      iso_num: 392,
      iso_2: "JP",
      iso_3: "JPN"
    },
    {
      country_id: 112,
      name_ru: "Иордания",
      name_en: "Jordan",
      iso_num: 400,
      iso_2: "JO",
      iso_3: "JOR"
    },
    {
      country_id: 113,
      name_ru: "Казахстан",
      name_en: "Kazakhstan",
      iso_num: 398,
      iso_2: "KZ",
      iso_3: "KAZ"
    },
    {
      country_id: 114,
      name_ru: "Кения",
      name_en: "Kenya",
      iso_num: 404,
      iso_2: "KE",
      iso_3: "KEN"
    },
    {
      country_id: 115,
      name_ru: "Кирибати",
      name_en: "Kiribati",
      iso_num: 296,
      iso_2: "KI",
      iso_3: "KIR"
    },
    {
      country_id: 116,
      name_ru: "Республика Корея",
      name_en: "Korea",
      iso_num: 410,
      iso_2: "KR",
      iso_3: "KOR"
    },
    {
      country_id: 117,
      name_ru: "КНДР",
      name_en: "Korea, North",
      iso_num: 408,
      iso_2: "KP",
      iso_3: "PRK"
    },
    {
      country_id: 118,
      name_ru: "Кувейт",
      name_en: "Kuwait",
      iso_num: 414,
      iso_2: "KW",
      iso_3: "KWT"
    },
    {
      country_id: 119,
      name_ru: "Киргизия",
      name_en: "Kyrgyzstan",
      iso_num: 417,
      iso_2: "KG",
      iso_3: "KGZ"
    },
    {
      country_id: 120,
      name_ru: "Лаос",
      name_en: "Laos",
      iso_num: 418,
      iso_2: "LA",
      iso_3: "LAO"
    },
    {
      country_id: 121,
      name_ru: "Латвия",
      name_en: "Latvia",
      iso_num: 428,
      iso_2: "LV",
      iso_3: "LVA"
    },
    {
      country_id: 122,
      name_ru: "Ливан",
      name_en: "Lebanon",
      iso_num: 422,
      iso_2: "LB",
      iso_3: "LBN"
    },
    {
      country_id: 123,
      name_ru: "Лесото",
      name_en: "Lesotho",
      iso_num: 426,
      iso_2: "LS",
      iso_3: "LSO"
    },
    {
      country_id: 124,
      name_ru: "Либерия",
      name_en: "Liberia",
      iso_num: 430,
      iso_2: "LR",
      iso_3: "LBR"
    },
    {
      country_id: 125,
      name_ru: "Ливия",
      name_en: "Libya",
      iso_num: 434,
      iso_2: "LY",
      iso_3: "LBY"
    },
    {
      country_id: 126,
      name_ru: "Лихтенштейн",
      name_en: "Liechtenstein",
      iso_num: 438,
      iso_2: "LI",
      iso_3: "LIE"
    },
    {
      country_id: 127,
      name_ru: "Литва",
      name_en: "Lithuania",
      iso_num: 440,
      iso_2: "LT",
      iso_3: "LTU"
    },
    {
      country_id: 128,
      name_ru: "Люксембург",
      name_en: "Luxembourg",
      iso_num: 442,
      iso_2: "LU",
      iso_3: "LUX"
    },
    {
      country_id: 129,
      name_ru: "Макао (Китай)",
      name_en: "Macau (China)",
      iso_num: 446,
      iso_2: "MO",
      iso_3: "MAC"
    },
    {
      country_id: 130,
      name_ru: "Республика Македония",
      name_en: "Republic of Macedonia",
      iso_num: 807,
      iso_2: "MK",
      iso_3: "MKD"
    },
    {
      country_id: 131,
      name_ru: "Мадагаскар",
      name_en: "Madagascar",
      iso_num: 450,
      iso_2: "MG",
      iso_3: "MDG"
    },
    {
      country_id: 132,
      name_ru: "Малави",
      name_en: "Malawi",
      iso_num: 454,
      iso_2: "MW",
      iso_3: "MWI"
    },
    {
      country_id: 133,
      name_ru: "Малайзия",
      name_en: "Malaysia",
      iso_num: 458,
      iso_2: "MY",
      iso_3: "MYS"
    },
    {
      country_id: 134,
      name_ru: "Мальдивские острова",
      name_en: "Maldives",
      iso_num: 462,
      iso_2: "MV",
      iso_3: "MDV"
    },
    {
      country_id: 135,
      name_ru: "Мали",
      name_en: "Mali",
      iso_num: 466,
      iso_2: "ML",
      iso_3: "MLI"
    },
    {
      country_id: 136,
      name_ru: "Мальта",
      name_en: "Malta",
      iso_num: 470,
      iso_2: "MT",
      iso_3: "MLT"
    },
    {
      country_id: 137,
      name_ru: "Маршалловы острова",
      name_en: "Marshall Islands",
      iso_num: 584,
      iso_2: "MH",
      iso_3: "MHL"
    },
    {
      country_id: 138,
      name_ru: "Мартиника",
      name_en: "Martinique",
      iso_num: 474,
      iso_2: "MQ",
      iso_3: "MTQ"
    },
    {
      country_id: 139,
      name_ru: "Мавритания",
      name_en: "Mauritania",
      iso_num: 478,
      iso_2: "MR",
      iso_3: "MRT"
    },
    {
      country_id: 140,
      name_ru: "Маврикий",
      name_en: "Mauritius",
      iso_num: 480,
      iso_2: "MU",
      iso_3: "MUS"
    },
    {
      country_id: 141,
      name_ru: "Майотта",
      name_en: "Mayotte",
      iso_num: 175,
      iso_2: "YT",
      iso_3: "MYT"
    },
    {
      country_id: 142,
      name_ru: "Мексика",
      name_en: "Mexico",
      iso_num: 484,
      iso_2: "MX",
      iso_3: "MEX"
    },
    {
      country_id: 143,
      name_ru: "Микронезия",
      name_en: "Micronesia",
      iso_num: 583,
      iso_2: "FM",
      iso_3: "FSM"
    },
    {
      country_id: 144,
      name_ru: "Молдова",
      name_en: "Moldova",
      iso_num: 498,
      iso_2: "MD",
      iso_3: "MDA"
    },
    {
      country_id: 145,
      name_ru: "Монако",
      name_en: "Monaco",
      iso_num: 492,
      iso_2: "MC",
      iso_3: "MCO"
    },
    {
      country_id: 146,
      name_ru: "Монголия",
      name_en: "Mongolia",
      iso_num: 496,
      iso_2: "MN",
      iso_3: "MNG"
    },
    {
      country_id: 147,
      name_ru: "Монтсеррат",
      name_en: "Montserrat",
      iso_num: 500,
      iso_2: "MS",
      iso_3: "MSR"
    },
    {
      country_id: 148,
      name_ru: "Марокко",
      name_en: "Morocco",
      iso_num: 504,
      iso_2: "MA",
      iso_3: "MAR"
    },
    {
      country_id: 149,
      name_ru: "Мозамбик",
      name_en: "Mozambique",
      iso_num: 508,
      iso_2: "MZ",
      iso_3: "MOZ"
    },
    {
      country_id: 150,
      name_ru: "Мьянма",
      name_en: "Myanmar",
      iso_num: 104,
      iso_2: "MM",
      iso_3: "MMR"
    },
    {
      country_id: 151,
      name_ru: "Намибия",
      name_en: "Namibia",
      iso_num: 516,
      iso_2: "NA",
      iso_3: "NAM"
    },
    {
      country_id: 152,
      name_ru: "Науру",
      name_en: "Nauru",
      iso_num: 520,
      iso_2: "NR",
      iso_3: "NRU"
    },
    {
      country_id: 153,
      name_ru: "Непал",
      name_en: "Nepal",
      iso_num: 524,
      iso_2: "NP",
      iso_3: "NPL"
    },
    {
      country_id: 154,
      name_ru: "Нидерланды",
      name_en: "Netherlands",
      iso_num: 528,
      iso_2: "NL",
      iso_3: "NLD"
    },
    {
      country_id: 155,
      name_ru: "Антильские острова",
      name_en: "Netherlands Antilles",
      iso_num: 530,
      iso_2: "AN",
      iso_3: "ANT"
    },
    {
      country_id: 156,
      name_ru: "Новая Каледония",
      name_en: "New Caledonia",
      iso_num: 540,
      iso_2: "NC",
      iso_3: "NCL"
    },
    {
      country_id: 157,
      name_ru: "Новая Зеландия",
      name_en: "New Zealand",
      iso_num: 554,
      iso_2: "NZ",
      iso_3: "NZL"
    },
    {
      country_id: 158,
      name_ru: "Никарагуа",
      name_en: "Nicaragua",
      iso_num: 558,
      iso_2: "NI",
      iso_3: "NIC"
    },
    {
      country_id: 159,
      name_ru: "Нигер",
      name_en: "Niger",
      iso_num: 562,
      iso_2: "NE",
      iso_3: "NER"
    },
    {
      country_id: 160,
      name_ru: "Нигерия",
      name_en: "Nigeria",
      iso_num: 566,
      iso_2: "NG",
      iso_3: "NGA"
    },
    {
      country_id: 161,
      name_ru: "Ниуэ",
      name_en: "Niue",
      iso_num: 570,
      iso_2: "NU",
      iso_3: "NIU"
    },
    {
      country_id: 162,
      name_ru: "остров Норфолк",
      name_en: "Norfolk Island",
      iso_num: 574,
      iso_2: "NF",
      iso_3: "NFK"
    },
    {
      country_id: 163,
      name_ru: "Марианские острова",
      name_en: "Northern Mariana Islands",
      iso_num: 580,
      iso_2: "MP",
      iso_3: "MNP"
    },
    {
      country_id: 164,
      name_ru: "Норвегия",
      name_en: "Norway",
      iso_num: 578,
      iso_2: "NO",
      iso_3: "NOR"
    },
    {
      country_id: 166,
      name_ru: "Оман",
      name_en: "Oman",
      iso_num: 512,
      iso_2: "OM",
      iso_3: "OMN"
    },
    {
      country_id: 167,
      name_ru: "Пакистан",
      name_en: "Pakistan",
      iso_num: 586,
      iso_2: "PK",
      iso_3: "PAK"
    },
    {
      country_id: 168,
      name_ru: "Палау",
      name_en: "Palau",
      iso_num: 585,
      iso_2: "PW",
      iso_3: "PLW"
    },
    {
      country_id: 169,
      name_ru: "Палестина",
      name_en: "Palestine",
      iso_num: 275,
      iso_2: "PS",
      iso_3: "PSE"
    },
    {
      country_id: 170,
      name_ru: "Панама",
      name_en: "Panama",
      iso_num: 591,
      iso_2: "PA",
      iso_3: "PAN"
    },
    {
      country_id: 171,
      name_ru: "Папуа - Новая Гвинея",
      name_en: "Papua new Guinea",
      iso_num: 598,
      iso_2: "PG",
      iso_3: "PNG"
    },
    {
      country_id: 172,
      name_ru: "Парагвай",
      name_en: "Paraguay",
      iso_num: 600,
      iso_2: "PY",
      iso_3: "PRY"
    },
    {
      country_id: 173,
      name_ru: "Перу",
      name_en: "Peru",
      iso_num: 604,
      iso_2: "PE",
      iso_3: "PER"
    },
    {
      country_id: 174,
      name_ru: "Филиппины",
      name_en: "Philippines",
      iso_num: 608,
      iso_2: "PH",
      iso_3: "PHL"
    },
    {
      country_id: 175,
      name_ru: "остров Питкэрн",
      name_en: "Pitcairn",
      iso_num: 612,
      iso_2: "PN",
      iso_3: "PCN"
    },
    {
      country_id: 176,
      name_ru: "Польша",
      name_en: "Poland",
      iso_num: 616,
      iso_2: "PL",
      iso_3: "POL"
    },
    {
      country_id: 177,
      name_ru: "Португалия",
      name_en: "Portugal",
      iso_num: 620,
      iso_2: "PT",
      iso_3: "PRT"
    },
    {
      country_id: 178,
      name_ru: "Пуэрто-Рико",
      name_en: "Puerto Rico",
      iso_num: 630,
      iso_2: "PR",
      iso_3: "PRI"
    },
    {
      country_id: 179,
      name_ru: "Катар",
      name_en: "Qatar",
      iso_num: 634,
      iso_2: "QA",
      iso_3: "QAT"
    },
    {
      country_id: 180,
      name_ru: "Реюньон",
      name_en: "Reunion",
      iso_num: 638,
      iso_2: "RE",
      iso_3: "REU"
    },
    {
      country_id: 181,
      name_ru: "Румыния",
      name_en: "Romania",
      iso_num: 642,
      iso_2: "RO",
      iso_3: "ROU"
    },
    {
      country_id: 182,
      name_ru: "Россия",
      name_en: "Russia",
      iso_num: 643,
      iso_2: "RU",
      iso_3: "RUS"
    },
    {
      country_id: 183,
      name_ru: "Руанда",
      name_en: "Rwanda",
      iso_num: 646,
      iso_2: "RW",
      iso_3: "RWA"
    },
    {
      country_id: 184,
      name_ru: "остров Святой Елены",
      name_en: "Saint Helena",
      iso_num: 654,
      iso_2: "SH",
      iso_3: "SHN"
    },
    {
      country_id: 185,
      name_ru: "Сент-Китс и Невис",
      name_en: "Saint Kitts and Nevis",
      iso_num: 659,
      iso_2: "KN",
      iso_3: "KNA"
    },
    {
      country_id: 186,
      name_ru: "Сент-Люсия",
      name_en: "Saint Lucia",
      iso_num: 662,
      iso_2: "LC",
      iso_3: "LCA"
    },
    {
      country_id: 187,
      name_ru: "Сен-Пьер и Микелон",
      name_en: "Saint Pierre and Miquelon",
      iso_num: 666,
      iso_2: "PM",
      iso_3: "SPM"
    },
    {
      country_id: 188,
      name_ru: "Сент-Винсент и Гренадины",
      name_en: "Saint Vincent and The Grenadines",
      iso_num: 670,
      iso_2: "VC",
      iso_3: "VCT"
    },
    {
      country_id: 189,
      name_ru: "о-ва Самоа",
      name_en: "Samoa",
      iso_num: 882,
      iso_2: "WS",
      iso_3: "WSM"
    },
    {
      country_id: 190,
      name_ru: "Сан-Марино",
      name_en: "San Marino",
      iso_num: 674,
      iso_2: "SM",
      iso_3: "SMR"
    },
    {
      country_id: 191,
      name_ru: "Сан-Томе и Принсипи",
      name_en: "Sao Tome and Principe",
      iso_num: 678,
      iso_2: "ST",
      iso_3: "STP"
    },
    {
      country_id: 192,
      name_ru: "Саудовская Аравия",
      name_en: "Saudi Arabia",
      iso_num: 682,
      iso_2: "SA",
      iso_3: "SAU"
    },
    {
      country_id: 194,
      name_ru: "Сенегал",
      name_en: "Senegal",
      iso_num: 686,
      iso_2: "SN",
      iso_3: "SEN"
    },
    {
      country_id: 195,
      name_ru: "Сейшельские острова",
      name_en: "Seychelles",
      iso_num: 690,
      iso_2: "SC",
      iso_3: "SYC"
    },
    {
      country_id: 196,
      name_ru: "Сьерра-Леоне",
      name_en: "Sierra Leone",
      iso_num: 694,
      iso_2: "SL",
      iso_3: "SLE"
    },
    {
      country_id: 197,
      name_ru: "Сингапур",
      name_en: "Singapore",
      iso_num: 702,
      iso_2: "SG",
      iso_3: "SGP"
    },
    {
      country_id: 198,
      name_ru: "Словакия",
      name_en: "Slovakia",
      iso_num: 703,
      iso_2: "SK",
      iso_3: "SVK"
    },
    {
      country_id: 199,
      name_ru: "Словения",
      name_en: "Slovenia",
      iso_num: 705,
      iso_2: "SI",
      iso_3: "SVN"
    },
    {
      country_id: 200,
      name_ru: "Соломоновы острова",
      name_en: "Solomon Islands",
      iso_num: 90,
      iso_2: "SB",
      iso_3: "SLB"
    },
    {
      country_id: 201,
      name_ru: "Сомали",
      name_en: "Somalia",
      iso_num: 706,
      iso_2: "SO",
      iso_3: "SOM"
    },
    {
      country_id: 202,
      name_ru: "ЮАР",
      name_en: "South Africa",
      iso_num: 710,
      iso_2: "ZA",
      iso_3: "ZAF"
    },
    {
      country_id: 203,
      name_ru: "Южная Георгия и Южные Сандвичевы о-ва",
      name_en: "South Georgia and The South Sandwich Islands",
      iso_num: 239,
      iso_2: "GS",
      iso_3: "SGS"
    },
    {
      country_id: 205,
      name_ru: "Испания",
      name_en: "Spain",
      iso_num: 724,
      iso_2: "ES",
      iso_3: "ESP"
    },
    {
      country_id: 206,
      name_ru: "Шри Ланка",
      name_en: "Sri Lanka",
      iso_num: 144,
      iso_2: "LK",
      iso_3: "LKA"
    },
    {
      country_id: 207,
      name_ru: "Судан",
      name_en: "Sudan",
      iso_num: 736,
      iso_2: "SD",
      iso_3: "SDN"
    },
    {
      country_id: 208,
      name_ru: "Суринам",
      name_en: "Suriname",
      iso_num: 740,
      iso_2: "SR",
      iso_3: "SUR"
    },
    {
      country_id: 209,
      name_ru: "о-ва Свалбард и Ян Майен",
      name_en: "Svalbard and Jan Mayen Islands",
      iso_num: 744,
      iso_2: "SJ",
      iso_3: "SJM"
    },
    {
      country_id: 210,
      name_ru: "Свазиленд",
      name_en: "Swaziland",
      iso_num: 748,
      iso_2: "SZ",
      iso_3: "SWZ"
    },
    {
      country_id: 211,
      name_ru: "Швеция",
      name_en: "Sweden",
      iso_num: 752,
      iso_2: "SE",
      iso_3: "SWE"
    },
    {
      country_id: 212,
      name_ru: "Швейцария",
      name_en: "Switzerland",
      iso_num: 756,
      iso_2: "CH",
      iso_3: "CHE"
    },
    {
      country_id: 213,
      name_ru: "Сирия",
      name_en: "Syria",
      iso_num: 760,
      iso_2: "SY",
      iso_3: "SYR"
    },
    {
      country_id: 214,
      name_ru: "Тайвань (Китай)",
      name_en: "Taiwan (China)",
      iso_num: 158,
      iso_2: "TW",
      iso_3: "TWN"
    },
    {
      country_id: 215,
      name_ru: "Таджикистан",
      name_en: "Tajikistan",
      iso_num: 762,
      iso_2: "TJ",
      iso_3: "TJK"
    },
    {
      country_id: 216,
      name_ru: "Танзания",
      name_en: "Tanzania",
      iso_num: 834,
      iso_2: "TZ",
      iso_3: "TZA"
    },
    {
      country_id: 217,
      name_ru: "Тайланд",
      name_en: "Thailand",
      iso_num: 764,
      iso_2: "TH",
      iso_3: "THA"
    },
    {
      country_id: 218,
      name_ru: "Восточный Тимор",
      name_en: "Timor-Leste",
      iso_num: 626,
      iso_2: "TL",
      iso_3: "TLS"
    },
    {
      country_id: 219,
      name_ru: "Того",
      name_en: "Togo",
      iso_num: 768,
      iso_2: "TG",
      iso_3: "TGO"
    },
    {
      country_id: 220,
      name_ru: "Токелау",
      name_en: "Tokelau",
      iso_num: 772,
      iso_2: "TK",
      iso_3: "TKL"
    },
    {
      country_id: 221,
      name_ru: "Тонга",
      name_en: "Tonga",
      iso_num: 776,
      iso_2: "TO",
      iso_3: "TON"
    },
    {
      country_id: 222,
      name_ru: "Тринидад и Тобаго",
      name_en: "Trinidad And Tobago",
      iso_num: 780,
      iso_2: "TT",
      iso_3: "TTO"
    },
    {
      country_id: 223,
      name_ru: "Тунис",
      name_en: "Tunisia",
      iso_num: 788,
      iso_2: "TN",
      iso_3: "TUN"
    },
    {
      country_id: 224,
      name_ru: "Турция",
      name_en: "Turkey",
      iso_num: 792,
      iso_2: "TR",
      iso_3: "TUR"
    },
    {
      country_id: 225,
      name_ru: "Туркменистан",
      name_en: "Turkmenistan",
      iso_num: 795,
      iso_2: "TM",
      iso_3: "TKM"
    },
    {
      country_id: 226,
      name_ru: "о-ва Туркс и Кайкос",
      name_en: "Turks and Caicos Islands",
      iso_num: 796,
      iso_2: "TC",
      iso_3: "TCA"
    },
    {
      country_id: 227,
      name_ru: "Тувалу",
      name_en: "Tuvalu",
      iso_num: 798,
      iso_2: "TV",
      iso_3: "TUV"
    },
    {
      country_id: 228,
      name_ru: "Уганда",
      name_en: "Uganda",
      iso_num: 800,
      iso_2: "UG",
      iso_3: "UGA"
    },
    {
      country_id: 229,
      name_ru: "Украина",
      name_en: "Ukraine",
      iso_num: 804,
      iso_2: "UA",
      iso_3: "UKR"
    },
    {
      country_id: 231,
      name_ru: "Арабские Эмираты",
      name_en: "United Arab Emirates",
      iso_num: 784,
      iso_2: "AE",
      iso_3: "ARE"
    },
    {
      country_id: 232,
      name_ru: "Великобритания",
      name_en: "UK",
      iso_num: 826,
      iso_2: "GB",
      iso_3: "GBR"
    },
    {
      country_id: 233,
      name_ru: "США",
      name_en: "USA",
      iso_num: 840,
      iso_2: "US",
      iso_3: "USA"
    },
    {
      country_id: 234,
      name_ru: "Отдаленные Острова США",
      name_en: "United States Minor Outlying Islands",
      iso_num: 581,
      iso_2: "UM",
      iso_3: "UMI"
    },
    {
      country_id: 235,
      name_ru: "Уругвай",
      name_en: "Uruguay",
      iso_num: 858,
      iso_2: "UY",
      iso_3: "URY"
    },
    {
      country_id: 236,
      name_ru: "Узбекистан",
      name_en: "Uzbekistan",
      iso_num: 860,
      iso_2: "UZ",
      iso_3: "UZB"
    },
    {
      country_id: 237,
      name_ru: "Вануату",
      name_en: "Vanuatu",
      iso_num: 548,
      iso_2: "VU",
      iso_3: "VUT"
    },
    {
      country_id: 238,
      name_ru: "Ватикан",
      name_en: "Holy See (Vatican)",
      iso_num: 336,
      iso_2: "VA",
      iso_3: "VAT"
    },
    {
      country_id: 239,
      name_ru: "Венесуэла",
      name_en: "Venezuela",
      iso_num: 862,
      iso_2: "VE",
      iso_3: "VEN"
    },
    {
      country_id: 240,
      name_ru: "Вьетнам",
      name_en: "Vietnam",
      iso_num: 704,
      iso_2: "VN",
      iso_3: "VNM"
    },
    {
      country_id: 241,
      name_ru: "Виргинские острова (Британские)",
      name_en: "Virgin Islands (British)",
      iso_num: 92,
      iso_2: "VG",
      iso_3: "VGB"
    },
    {
      country_id: 242,
      name_ru: "Виргинские острова (США)",
      name_en: "Virgin Islands (US)",
      iso_num: 850,
      iso_2: "VI",
      iso_3: "VIR"
    },
    {
      country_id: 244,
      name_ru: "о-ва Валлис и Футуна",
      name_en: "Wallis and Futuna Islands",
      iso_num: 876,
      iso_2: "WF",
      iso_3: "WLF"
    },
    {
      country_id: 245,
      name_ru: "Западная Сахара",
      name_en: "Western Sahara",
      iso_num: 732,
      iso_2: "EH",
      iso_3: "ESH"
    },
    {
      country_id: 246,
      name_ru: "Йемен",
      name_en: "Yemen",
      iso_num: 887,
      iso_2: "YE",
      iso_3: "YEM"
    },
    {
      country_id: 248,
      name_ru: "Замбия",
      name_en: "Zambia",
      iso_num: 894,
      iso_2: "ZM",
      iso_3: "ZMB"
    },
    {
      country_id: 249,
      name_ru: "Зимбабве",
      name_en: "Zimbabwe",
      iso_num: 716,
      iso_2: "ZW",
      iso_3: "ZWE"
    },
    {
      country_id: 250,
      name_ru: "Афганистан",
      name_en: "Afghanistan",
      iso_num: 4,
      iso_2: "AF",
      iso_3: "AFG"
    },
    {
      country_id: 251,
      name_ru: "Республика Абхазия",
      name_en: "Abkhazia",
      iso_num: 895,
      iso_2: "AB",
      iso_3: "ABH"
    },
    {
      country_id: 252,
      name_ru: "Аландские острова",
      name_en: "Aland Islands",
      iso_num: 248,
      iso_2: "AX",
      iso_3: "ALA"
    },
    {
      country_id: 253,
      name_ru: "Черногория",
      name_en: "Montenegro",
      iso_num: 499,
      iso_2: "ME",
      iso_3: "MNE"
    }
  ]
};

const getters = {
  countryList(state) {
    return state.countries;
  },
  countryNameRu: state => code => {
    if (state.countries && state.countries.length > 0 && code != null) {
      let name = state.countries.find(el => el.iso_2 === code);
      if (name != undefined) return name.name_ru
      else {
        return "Test MAP"
      }
    } else {
      return "";
    }
  },
  countryCodeByNum: state => num => {
    if (state.countries && num) {
      let item = state.countries.find(el => el.iso_num === num);
      if (item) return item.iso_2
      else "ZZ"
    } else {
      return "ZZ"
    }
  },
  countryNameEn: state => code => {
    if (state.countries && state.countries.length > 0 && code != null) {
      let name = state.countries.find(el => el.iso_2 === code);
      if (name != undefined) return name.name_en
      else {
        return "Test MAP"
      }
    } else {
      return "";
    }
  }
};

export default {
  state,
  getters
};